import { render, staticRenderFns } from "./lot.vue?vue&type=template&id=3a8bf603&scoped=true&"
import script from "./lot.vue?vue&type=script&lang=js&"
export * from "./lot.vue?vue&type=script&lang=js&"
import style0 from "./lot.vue?vue&type=style&index=0&id=3a8bf603&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bf603",
  null
  
)

export default component.exports